interface LoadingStateProps {
  /** Number of skeleton rows to show */
  rows?: number
  className?: string
}

export function LoadingState({ rows = 5, className = '' }: LoadingStateProps) {
  return (
    <div className={`space-y-3 ${className}`}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse h-10 bg-gray-100 rounded-lg"
          style={{ width: `${100 - i * 5}%` }}
        />
      ))}
    </div>
  )
}
